import { render, staticRenderFns } from "./deletepop.vue?vue&type=template&id=49b043fe&scoped=true"
import script from "./deletepop.vue?vue&type=script&lang=js"
export * from "./deletepop.vue?vue&type=script&lang=js"
import style0 from "./deletepop.vue?vue&type=style&index=0&id=49b043fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b043fe",
  null
  
)

export default component.exports